import { useState } from 'react';
import { TextField, IconButton, InputAdornment, Visibility, VisibilityOff } from 'src/components';
import { useIsMobile } from 'src/hooks';

export function TextFieldInput(props) {
  const [showPassword, setShowPassword] = useState(false);
  const isMobile = useIsMobile();
  const isPassword = props.type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : props.type;

  const handleToggleVisibility = () => {
    setShowPassword(prev => !prev);
  };

  return (
    <TextField
      margin="dense"
      required
      fullWidth
      id={props.id}
      label={props.label}
      value={props.value}
      onChange={props.onChange}
      size="small"
      type={inputType}
      error={props.error}
      helperText={props.helperText}
      autoFocus={props.autoFocus === true}
      defaultValue={props.defaultValue}
      inputProps={{ style: { fontSize: isMobile ? 16 : 12 } }}
      InputLabelProps={{ style: { fontSize: isMobile ? 16 : 12 } }}
      sx={{ backgroundColor: 'white', borderRadius: 2 }}
      InputProps={{
        endAdornment: isPassword && (
          <InputAdornment position="end">
            <IconButton
              onClick={handleToggleVisibility}
              edge="end"
              size="small"
              sx={{ padding: 0.5 }}
            >
              {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      FormHelperTextProps={{
        sx: {
          fontSize: '10px',
          marginLeft: 1,
          color: 'error.main',
        }
      }}
    />
  );
}
